require('./google-places-search.js');
const {ActivityController} = require('./controllers/activity-controller.ts');

$(document).ready(_ => {
    const activitiesContainer = $('#activities-container');
    if(activitiesContainer.length > 0) {
        const AC = new ActivityController(
            activitiesContainer,
            $('#activities-search-form'),
            $('#paginator-container'),
            $('#paginator-container'),
            null,
            {
                mosOnly: 0,
                seatsAvailable: 1,
                byFriends: 0,
                perPage: 12,
                new: 0
            }
        );
        AC.afterRender(_ => {
            renderSlider(activitiesContainer);
        });
        AC.find();
    }

    const usersContainer = $('#users-container');
    if(usersContainer.length > 0) {
        const searchForm = $('#users-search-form');
        const aContainer = $('#users-container');
        const AC = new ActivityController(
            aContainer,
            searchForm,
            $('#pagination-options'),
            $('#paginator-container'),
            null,
            {},
            null,
            'users'
        );
        AC.find();
    }
});

function renderSlider(component) {
    const self = $(component);
    self.slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    self.find('.slick-prev').attr('aria-hidden', true);
    self.find('.slick-next').attr('aria-hidden', true);
}
